import { useAxios } from 'hooks/useAxios';
import { AxiosErrorHandler } from 'shared/Helpers';
import { BASE_URL, BASE_URL_V2 } from 'shared/constants';

const VITE_APP_UNSECURE_ROUTE = import.meta.env.VITE_APP_UNSECURE_ROUTE ?? 'secure';

export const useExtraApi = () => {
  const { axios } = useAxios(BASE_URL);

  const getMe = async () => {
    try {
      const res = await axios.get(`/user/me`, {
        baseURL: BASE_URL_V2
      });
      return res.data;
    } catch (e) {
      AxiosErrorHandler(e);
    }
  };

  const updateMe = async (data: any) => {
    try {
      const filteredData = {
        email: data.email,
        given_name: data.given_name,
        family_name: data.family_name,
        user_metadata: {
          title: data.user_metadata?.title,
          phone: data.user_metadata?.phone,
          color: data.user_metadata?.color
        }
      };
      const res = await axios.put(`/secure/me`, filteredData);
      return res.data;
    } catch (e) {
      AxiosErrorHandler(e);
    }
  };

  const getSupplierDynamicsStats = async () => {
    try {
      const res = await axios.get(`${VITE_APP_UNSECURE_ROUTE}/supplierDynamics/stats`);
      return res.data;
    } catch (e) {
      AxiosErrorHandler(e);
    }
  };

  const sendVerificationEmail = async () => {
    try {
      const res = await axios.post(`/secure/send-verification`);
      return res.data;
    } catch (e) {
      AxiosErrorHandler(e);
    }
  };

  /**
   * Get File from API
   * @param filename
   */
  const getFile = async (filename: string) => {
    const { data } = await axios.get(`/secure/file/${encodeURIComponent(filename)}`, {
      responseType: 'blob'
    });
    return data;
  };

  const getStatusLov = async () => {
    try {
      const res = await axios.get(`/lov/status`, {
        baseURL: BASE_URL_V2
      });
      if (res?.status === 200) {
        return res?.data;
      }
      return Promise.reject(Error(res?.data?.message || res?.statusText || 'Failed to fetch status lov'));
    } catch (e) {
      AxiosErrorHandler(e);
    }
  };

  return {
    getMe,
    updateMe,
    getSupplierDynamicsStats,
    sendVerificationEmail,
    getFile,
    getStatusLov
  };
};
